/**
 * Staff roles (users.role). Patients are role 2 and never sign in to this panel.
 * The numbers are the server's: they are NOT in display order - use ROLE_ORDER for that.
 */
export const DOCTOR = 1;

/** The old name for DOCTOR (role 1 was "clinical admin" before the three-role split). */
export const CLINICAL_ADMIN = DOCTOR;

export const SUPER_ADMIN = 3;

export const ADMIN = 4;

/** How the roles are shown, e.g. on the Clinicians page, in role history and in the header search. */
export const ROLE_LABELS = {
    [DOCTOR]: "Doctor",
    [ADMIN]: "Admin",
    [SUPER_ADMIN]: "Super admin",
};

/** The order the roles are listed in (Change role, anywhere else they are offered together). */
export const ROLE_ORDER = [DOCTOR, ADMIN, SUPER_ADMIN];

/** Every role that signs in to this panel. */
export const STAFF_ROLES = ROLE_ORDER;

/** Whether this role is a staff role (Doctor, Admin or Super admin) - never true for a patient. */
export function isStaffRole(role) {
    return STAFF_ROLES.includes(role);
}
